export default __webpack_public_path__ + "static/media/O.8192f79c.svg";